<template>
  <div class="goods-detail-wrapper">
    <div class="content-header" v-if="type == 0">选择会员购买方式</div>
    <div class="card-wrapper" v-if="type != 2">
      <div style="position: relative">
        <img
          class="card-image"
          :src="require('../../assets/imgs/payment/monthly-card.png')"
        />
        <div class="card-button" @click="this.payMonthlyCard">立即购买</div>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <img
          class="card-footer-image"
          :src="require('../../assets/imgs/payment/monthly-card-footer.png')"
        />
      </div>
    </div>
    <div class="card-wrapper" v-if="type != 1">
      <div style="position: relative">
        <img
          class="card-image"
          :src="require('../../assets/imgs/payment/yearly-card.png')"
        />
        <div class="card-button" @click="this.payYearlyCard">立即购买</div>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <img
          class="card-footer-image"
          :src="require('../../assets/imgs/payment/yearly-card-footer.png')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  groupBuyGoodsInfo,
  weixincreate,
  groupBuyGoodsShow,
} from "@/api/groupbuy";
import { wxpay } from "@/lib/wxShare";
import _ from "lodash";

export default {
  data() {
    return {
      goodsInfo: null,
      list: [],
      webUrl: location.origin + "/h5/introduce/",
      monthlyCard: {},
      yearlyCard: {},
      type: 0, // 1 月卡 2 年卡
    };
  },

  created() {
    //加载商品信息
    // this.request_groupBuyGoodsInfo();
  },

  activated() {
    //加载商品信息
    this.request_groupBuyGoodsInfo();
    const type = this.$router.currentRoute.query.type
    if (type) {
      this.type = type
    }
  },
  methods: {
    //点击回到首页
    actionForHome() {
      // window.location.replace(window.origin)
      this.$router.replace({ path: "/home", query: { entry: "pay_page" } });

      // this.$router.back(-1);
    },
    payMonthlyCard() {
        this.request_weixincreate({groupBuyGoodsId: this.monthlyCard.groupBuyGoodsId,priceType: 1})
    },
    payYearlyCard() {
        this.request_weixincreate({groupBuyGoodsId: this.yearlyCard.groupBuyGoodsId,priceType: 1})
    },

    //========net==========
    //下单
    request_weixincreate(params) {


      this.$loading.show();
      weixincreate(params)
        .then((res) => {
          this.$loading.hide();
            let params = res.data;
            wxpay(params, this._paySuccessBlock);
        })
        .catch((err) => {
          this.$loading.hide();
        });
    },

    //加载商品信息
    request_groupBuyGoodsInfo() {
      this.$loading.show();
      groupBuyGoodsShow()
        .then((res) => {
          this.$loading.hide();
          // this.list = this.pricesInfo.groupBuyGoodsShows || [];

          this.list = res.data.groupBuyGoodsShows;



          this.monthlyCard = _.find(this.list, (item) => item.vipType == "月" && item.groupBuyGoodsId == 1);
          this.yearlyCard = _.find(this.list, (item) => item.vipType == "年" && item.groupBuyGoodsId == 3);
        })
        .catch(() => {
          this.$loading.hide();
        });
    },

    //微信支付的回调
    _paySuccessBlock(payResult) {
      //判断是否是微信
      let ua = navigator.userAgent.toLowerCase();
      let isWeixin =
        ua.match(/MicroMessenger/i) == "micromessenger" ? true : false;
      if (isWeixin) {
        if (payResult.err_msg == "get_brand_wcpay_request:ok") {
          //支付成功
          // this.$router.push({
          //   path: '/paySuccess',
          //   query: {
          //     orderId: this.orderId,
          //   }
          // })
          this.$toast("恭喜您购买成功");
        } else {
          //支付失败
          this.$toast({
            message: "未支付或支付失败",
            duration: 1000,
          });
        }
      }
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../stylesheet/common.styl';

.goods-detail-wrapper {
  background: linear-gradient(180deg, #243042 0%, #0E0E0E 100%);
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.content-header {
  color: #E6D9BB;
  font-size: 18px;
  font-weight: bold;
}

.card-wrapper {
  margin-top: 20px;
  width: 100%;
}

.card-image {
  width: 100%;
}

.card-footer-image {
  width: 80%;
}

.card-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 13px;
  font-weight: bold;
  padding: 0 20px;
  line-height: 34px;
  background: linear-gradient(90deg, #E2B788 0%, #FED7A9 100%);
  border-radius: 17px;
  color: #664E22;
}
</style>



// WEBPACK FOOTER //
// app/pages/pay/Payment.vue